<template>
  <nav
    v-if="hasItems"
    class="text-gray-500 font-semibold"
    aria-label="breadcrumb"
    dusk="breadcrumbs"
  >
    <ol class="flex items-center flex-wrap">
      <li
        v-for="(item, index) in exceptFirstBreadcrumb"
        :key="index"
        v-bind="{
          'aria-current': index === exceptFirstBreadcrumb.length - 1 ? 'page' : null,
        }"
      >
        <div class="flex items-center">
          <Link
            v-if="item.path !== null && index < exceptFirstBreadcrumb.length - 1"
            :href="$url(item.path)"
            class="link-default"
          >
            {{ item.name }}
          </Link>
          <span v-else>{{ item.name }}</span>
          <Icon
            v-if="index < exceptFirstBreadcrumb.length - 1"
            type="chevron-right"
            class="w-4 h-4 mx-2 text-gray-300 dark:text-gray-700"
          />
        </div>
      </li>
      <li>
        <div class="flex items-center">
          <Icon
            type="chevron-left"
            class="w-4 h-4 mx-2 text-gray-300 dark:text-gray-700"
          />
          <a href="javascript:history.back()" class="link-default">
            {{ __('Go back') }}
          </a>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['breadcrumbs']),

    hasItems() {
      return this.breadcrumbs.length > 2;
    },
    exceptFirstBreadcrumb() {
      return this.breadcrumbs.slice(1);
    },
  },
};
</script>
